import { log } from './_logs'

export async function initVumeter(videoElt, canvas, audio, { } = {}) {

	log('initVumeter...')

	const v = videoElt

	// if (v.muted) {
	// 	return {};
	// }

	v.crossOrigin = 'anonymous'


	let stream
	do {
		stream = v.srcObject || v.src
		await new Promise(resolve => setTimeout(resolve, 500))
	} while (!stream)

	const audioContext = new AudioContext({
		latencyHint: 'interactive',
		sampleRate: 44100,
	})

	const analyserLeft = new AnalyserNode(audioContext, {
		fftSize: 2048,
		smoothingTimeConstant: 0.75,
		maxDecibels: -25,
		minDecibels: -78,
	});

	const analyserRight = new AnalyserNode(audioContext, {
		fftSize: 2048,
		smoothingTimeConstant: 0.75,
		maxDecibels: -25,
		minDecibels: -78,
	});

	let source
	try {
	if (!(stream instanceof MediaStream)) {
		log('vuemeter linked on MediaElement...')
		source = audioContext.createMediaElementSource(videoElt)
		log('vuemeter linked on MediaElement... OK')
	}
	else {
		log('vuemeter linked on MediaStream...')
		source = audioContext.createMediaStreamSource(stream)
		log('vuemeter linked on MediaStream... OK')
	}
	}
	catch (e) {
		console.warn('unable to initialise audioContect Source :', e.message)
		return {noAudio: true}
	}

	// Split the channels
	const splitter = audioContext.createChannelSplitter(2);

	// Connect source to splitter
	source.connect(splitter);

	// Connect splitter outputs to analyzers
	splitter.connect(analyserLeft, 0); // Left channel
	splitter.connect(analyserRight, 1); // Right channel

	// // Création du merger pour recombiner en stéréo
	// const merger = audioContext.createChannelMerger(2);
	// analyserLeft.connect(merger, 0, 0);  // Connecter à gauche
	// analyserRight.connect(merger, 0, 1); // Connecter à droite

	const dest = audioContext.createMediaStreamDestination()
	source.connect(dest)

	audio.srcObject = dest.stream
	await audio.play()


	return {
		analyser: analyserLeft,
		analyserLeft,
		analyserRight,
		audioContext,
		source
	}
}